class MouseCursor
    constructor: (el) ->
        @.$el = el
        if !@.$el.classList.contains 'mouse-cursor--bound'
            @.$mouseCursorAreas = undefined
            @.$mouseCursorHideElements = undefined
            @.shown = false
            @.forcedHide = false
            @.color = undefined
            @.icon = undefined

            @.$el.classList.add 'mouse-cursor--bound'
            @.InitEvents()
            @.GetMouseCursorElements()
        return
    
    InitEvents: ->
        self = @
        # change position by the one of the mouse if mouse cursor element is shown
        document.addEventListener 'mousemove', (e) ->
            if self.shown
                self.$el.style.left = e.clientX + 'px'
                self.$el.style.top = e.clientY + 'px'
            return

        # refresh the trigger elements list and listeners if new elements are appended to the DOM
        window.addEventListener 'bind-components', (e) ->
            self.GetMouseCursorElements()
            return
        return

    GetMouseCursorElements: ->
        # get all trigger elements and bind enter/leave listeners
        @.$mouseCursorAreas = document.querySelectorAll '.mouse-cursor--area:not(.mouse-cursor--bound)'
        self = @
        @.$mouseCursorAreas
            .forEach (mouseCursorArea) ->
                mouseCursorArea.addEventListener 'mouseover', (e) ->
                    if !self.forcedHide && !(window.innerWidth <= 768 && @.classList.contains('mouse-cursor--not-mobile'))
                        self.ShowMouseCursor(@)
                mouseCursorArea.addEventListener 'mouseleave', (e) ->
                    self.HideMouseCursor()
                    return
                mouseCursorArea.classList.add 'mouse-cursor--bound'
                return
        return

        @.$mouseCursorHideElements = document.querySelectorAll '.mouse-cursor--hide:not(.mouse-cursor--bound)'
            .forEach (mouseCursorElements) ->
                mouseCursorElements.addEventListener 'mouseenter', (e) ->
                    self.forcedHide = true
                    self.HideMouseCursor()
                    return
                mouseCursorElements.addEventListener 'mouseleave', (e) ->
                    self.forcedHide = false
                    return
                mouseCursorElements.classList.add 'mouse-cursor--bound'
                return
        return
    
    ShowMouseCursor: (el) ->
        @.$el.classList.add 'mouse-cursor--shown'
        @.shown = true
        document.getElementById('site').classList.add 'mouse-cursor-used'
        # check for icon change if an element was handed over
        if el
            # check if classlist contains 'mouse-cursor--use-....' and get the corresponding icon name if so
            for i in [0..el.classList.length]
                if /mouse-cursor--use-.*/.test(el.classList[i])
                    @.ChangeMouseCursorIcon el.classList[i].substr(18,el.classList[i].length)
                if /mouse-cursor--color-.*/.test(el.classList[i])
                    @.ChangeMouseCursorColor el.classList[i].substr(20,el.classList[i].length)
        return

    HideMouseCursor: ->
        @.$el.classList.remove 'mouse-cursor--shown'
        @.shown = false 
        @.ResetMouseCursorIcon()
        document.getElementById('site').classList.remove 'mouse-cursor-used'
        return

    ChangeMouseCursorColor: (color) ->
        @.ResetMouseCursorColor()
        @.color = color
        @.$el.classList.add 'mouse-cursor--' + @.color
        return

    ResetMouseCursorColor: ->
        if @.color
            @.$el.classList.remove 'mouse-cursor--' + @.color
            @.color = undefined
        return

    ChangeMouseCursorIcon: (icon) ->
        @.ResetMouseCursorIcon()
        @.icon = icon
        @.$el.classList.add 'mouse-cursor--' + @.icon
        return

    ResetMouseCursorIcon: ->
        if @.icon
            @.$el.classList.remove  'mouse-cursor--' + @.icon
            @.icon = undefined
        return

BindMouseCursors = ->
    document.querySelectorAll '.mouse-cursor:not(.mouse-cursor--bound)'
        .forEach (el) ->
            new MouseCursor el
            return
    return

window.addEventListener 'bind-components', BindMouseCursors